import type { PropsWithChildren } from 'react';

export const ExternalLink = ({
  children,
  ...props
}: PropsWithChildren<JSX.IntrinsicElements['a'] & { block?: boolean }>) => (
  <a {...props}>{children}</a>
);
